import { render, staticRenderFns } from "./v-detail-view-invoice.vue?vue&type=template&id=012e1906&"
import script from "./v-detail-view-invoice.vue?vue&type=script&lang=js&"
export * from "./v-detail-view-invoice.vue?vue&type=script&lang=js&"
import style0 from "./v-detail-view-invoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports